import { Types, UserId } from "@inrev/common";
import { cn } from "@portal/components/lib/utils";
import { Text } from "@portal/components/primitives";
import { AdminAssigneeControls } from "./AdminAssigneeControls";

export type AdminAssigneeInlineControlsProps = {
	assignedEntity: Types.UnderwriterAssignment.UnderwriterAssignmentEntity;
	currentAssignee: UserId;
	label?: string;
	trackingId?: string;
	/** Root overrides — pass `pt-0` where the parent owns the vertical rhythm. */
	className?: string;
	avatarClassName?: string;
};

export const AdminAssigneeInlineControls = ({
	assignedEntity,
	currentAssignee,
	label,
	trackingId,
	className,
	avatarClassName,
}: AdminAssigneeInlineControlsProps) => {
	return (
		<div className={cn("flex items-center space-x-[8px] pt-[6px]", className)}>
			<Text type="caption" color="secondary" className="font-[550]">
				{label ?? "Underwriter"}
			</Text>
			<AdminAssigneeControls
				assignedEntity={assignedEntity}
				currentAssignee={currentAssignee}
				trackingId={trackingId}
				avatarClassName={avatarClassName}
			/>
		</div>
	);
};
